import React, { Component } from 'react';
import { connect } from 'react-redux';
import Subscribers from './subscribers';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';

@connect(
  state=>state.tenant,
  null
)
class SubscriberCon extends Component{
  componentDidMount() {
    $("#activity, #project-context").show();
  }
  render() {
    let block = !this.props.tenantInfo.name;
    return (
      <BlockUi tag="div"
               blocking={block}
               loader={<Loader active type="ball-grid-pulse" color="#808080"/>}
               renderChildren={false}>
        <Subscribers />
      </BlockUi>
    );
  }
}

export default SubscriberCon;


// WEBPACK FOOTER //
// ./src/container/dashboard/model/subscriberCon.js